import axios from 'axios'
import { AuthModel, LoginModel, UserModel } from './_models'

const API_URL = process.env.DELNIE_ACCOUNT_API_URL

// export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}AdminUsers/getProfile`
// export const LOGIN_URL = `${API_URL}/login`
export const LOGIN_URL = `${API_URL}AdminUsers/adminLogin`
export const REGISTER_URL = `${API_URL}AdminUsers/adminRegister
`
export const REQUEST_PASSWORD_URL = `${API_URL}forgot_password`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<LoginModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {

  let data = {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
  }
  return axios.post(REGISTER_URL, { data: data })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<any>(GET_USER_BY_ACCESSTOKEN_URL + "?access_token=" + token, {
    api_token: token
  })
}
